// @flow
import React from 'react';
import { token } from '@atlaskit/tokens';
import Progress from 'redux-progress';
import { connect } from 'react-redux';
import styled from 'styled-components';
import t from 'modules/i18n/intl';

import type { State, Dispatch } from 'model/State';
import type { UserDetails } from 'modules/auth/model/UserDetails';
import Link from 'components/common/Link';
import { Font, Dimensions } from 'components/visuals';
import config from 'appconfig';
import { setSwitchUserEmail } from 'modules/mac/duck/actions/configUser';

type StateProps = {
  userDetails: Progress<UserDetails | null>,
};

type DispatchProps = {
  setSwitchUserEmail: () => void,
};

type Props = StateProps & DispatchProps;

const Wrapper = styled.div`
  color: ${token('color.text', '#172B4D')};
  font-family: ${Font.family};
  font-size: 12px;
  height: ${Dimensions.units(2)}px;
  text-align: right;
`;

const LoggedInStatus = (props: {
  userDetails: UserDetails,
  macLink: string,
  setSwitchUserEmail: () => void,
}) => {
  const handleMACSwitchUserOnLogout = () => {
    props.setSwitchUserEmail();
  };
  return (
    <Wrapper>
      <Link to={props.macLink} className="pii">
        {props.userDetails.displayName || t('navigation.header.my-account')}
      </Link>
      <span>
        (
        <Link to={config.logoutUrl()} onClick={handleMACSwitchUserOnLogout}>
          {t('navigation.header.logout')}
        </Link>
        )
      </span>
    </Wrapper>
  );
};

const AnonymousStatus = (props: { macLink: string }) => (
  <Wrapper>
    <Link to={props.macLink}>{t('navigation.header.my-account')}</Link>
  </Wrapper>
);

export const VisualLoginStatus = (props: Props) => {
  const macLink = `${config.root}/my`;

  return (
    props.userDetails.ifSuccess(
      (userDetails) =>
        userDetails && (
          <LoggedInStatus
            userDetails={userDetails}
            macLink={macLink}
            setSwitchUserEmail={props.setSwitchUserEmail}
          />
        ),
    ) || <AnonymousStatus macLink={macLink} />
  );
};

const mapStateToProps = (state: State): StateProps => ({
  userDetails: state.auth.userDetails,
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  setSwitchUserEmail: () => dispatch(setSwitchUserEmail('')),
});

export default connect(mapStateToProps, mapDispatchToProps)(VisualLoginStatus);
